import { Getters, Mutations, Actions, Module } from 'vuex-smart-module'

export class Alert {
  color?: 'warning' | 'error' | 'primary' | 'success'
  type: 'warning' | 'error' | 'info' | 'success'
  message: string
  id: number

  constructor(type: 'warning' | 'error' | 'info' | 'success', message: string) {
    this.color = type === 'info' ? 'primary' : type
    this.type = type
    this.message = message || (type === 'error' ? 'Операция не выполнена' : '...')
    this.id = new Date().getMilliseconds()
  }
}

export interface AlertParams {
  type: 'warning' | 'error' | 'info' | 'success'
  message: string
  duration?: number
}

export class AlertState {
  items: Array<Alert> = []
}

export class AlertGetters extends Getters<AlertState> {}

export class AlertMutations extends Mutations<AlertState> {
  openAlert({ type, message, duration = 8000 }: AlertParams) {
    const alert = new Alert(type, message)
    this.state.items.push(alert)

    setTimeout(() => {
      this.state.items.splice(
        this.state.items.findIndex(item => item.id === alert.id),
        1
      )
    }, duration)
  }
}

export class AlertActions extends Actions<AlertState, AlertGetters, AlertMutations> {}

export const alert = new Module<AlertState, AlertGetters, AlertMutations, AlertActions>({
  state: AlertState,
  getters: AlertGetters,
  mutations: AlertMutations,
  actions: AlertActions,
})
